// The Quantfolio frame. `allow-same-origin` is required (QP needs its own
// cookies/storage for the SSO round trip) and is safe here because the framed
// origin is QP, not Andersen — the sandbox never grants QP access to our
// origin. Popups may escape the sandbox so e-signing (BankID etc., which
// refuses to be framed) can open in its own window. See
// docs/quantfolio-embed.md §6.
export function QpFrame({ embedUrl, flowName }: { embedUrl: string; flowName: string | null }) {
  return (
    <iframe
      src={embedUrl}
      title={`Quantfolio — ${flowName ?? "flow session"}`}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
      allow="clipboard-write; publickey-credentials-get *"
      referrerPolicy="strict-origin-when-cross-origin"
      style={{
        display: "block",
        width: "100%",
        flex: 1,
        minHeight: 520,
        height: "calc(100vh - 260px)",
        border: "1px solid var(--c-border)",
        borderRadius: "var(--r-md)",
        background: "var(--c-paper)",
      }}
    />
  );
}
